import React, { Provider, useEffect, useState } from 'react';
import './Mint.scss';
import Minter from 'contracts/Minter.sol/Minter.json';
import Web3 from 'web3';
import Moralis from 'moralis';
import { useMoralis } from 'react-moralis';

const chainId = '0x1'; //Ethereum Mainnet
const minterContractAddress = '0xd79EA74bfcC25dA642e395DfbCc67e8c05FCd952';

function Mint() {
  const [ethAccount, setEthAccount] = useState();
  // const [web3, setWeb3]: any = useState(null);
  const { authenticate, isAuthenticated, isAuthenticating, user, account, logout } = useMoralis();

  useEffect(() => {
    if (isAuthenticated) {
      // add your logic here
      const userEth = user;
      const userEthAddress = userEth!.get('ethAddress');
      console.log('logged in user:', user);
      console.log(`user ethAddress: ${userEthAddress}`);
      setEthAccount(userEth!.get('ethAddress'));
      enableWeb3onMoralis();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  const enableWeb3onMoralis = async () => {
    await Moralis.enableWeb3();
    // @ts-ignore: Unreachable code error
    // const web3Js = new Web3(Moralis.provider);
    // setWeb3(web3Js);
  };

  const login = async () => {
    if (!isAuthenticated) {
      await Moralis.switchNetwork(chainId);
      await authenticate({ signingMessage: 'Log in using Moralis' })
        .then(function (user) {
          const userEth = user;
          const userEthAddress = userEth!.get('ethAddress');

          console.log('logged in user:', user);
          console.log(`user ethAddress: ${userEthAddress}`);
          setEthAccount(userEthAddress);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  const logOut = async () => {
    await logout();
    setEthAccount(undefined);
    console.log('logged out');
  };

  const connectWallet = async () => {
    await enableWeb3onMoralis();
    await login();
  };

  const mintOne = async () => {
    const sendOptions = {
      contractAddress: minterContractAddress,
      functionName: 'mint',
      abi: Minter.abi,
      msgValue: Moralis.Units.ETH(0),
      params: {
        to: ethAccount,
      },
    };

    const transaction = await Moralis.executeFunction(sendOptions);
    console.log('transaction.hash', transaction.hash);
  };

  const minting = async () => {
    try {
      await mintOne();
    } catch (error) {
      console.log('minting error', { error });

      // if (error?.error?.message) {
      //   setErrorMessage(error.error.message);
      // } else {
      //   setErrorMessage(error.message);
      // }
      // setIsMinting(false);
    }
  };

  return (
    <div className="mintContainer">
      <button onClick={logOut} disabled={isAuthenticating}>
        Logout
      </button>
      {ethAccount ? (
        <React.Fragment>
          <button className="mint-btn" id="connect-wallet-btn" onClick={minting}>
            Free Mint
          </button>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <button className="mint-btn" id="connect-wallet-btn" onClick={connectWallet}>
            Connect Wallet
          </button>
        </React.Fragment>
      )}
    </div>
  );
}

export default Mint;
